export const cleanNumberRegex = /[^\.\d]+/g

export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const phoneRegex = /[^\d]/g

export const currencyFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  currencyDisplay: 'narrowSymbol',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const currencyDecimalFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  currencyDisplay: 'narrowSymbol',
});

export const percentageDecimalFormat = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 3,
});

export const calculateMonthlyPayment = function(balance, interestRate, terms) {
  const interestTerms = (1 - Math.pow(1 + interestRate, -terms));

  if (interestRate == 0 && interestTerms == 0) {
    return balance / terms;
  }

  return balance * (interestRate / interestTerms)
}

export const calculateTotalLoanInterest = function(balance, interestRate, terms) {

  let totals = {
    interest: 0,
    principal: 0,
  }

  let payment = calculateMonthlyPayment(balance, interestRate, terms)

  /**
   * Loop that calculates the monthly Loan amortization amounts then adds
   * them to the return string
   */
  for (var count = 0; count < terms; ++count) {

    //calc the in-loop interest amount and display
    let interest = balance * interestRate;
    let monthlyPrincipal = payment - interest;

    totals.interest += interest
    balance -= monthlyPrincipal
  }

  return totals.interest
}

export const formatCalculatorValue = function(value, format) {

  let cleanedNumericValue = value.toString().replace(cleanNumberRegex, '')

  if (format === 'currency') {
    return currencyDecimalFormat.format(cleanedNumericValue)
  } else if (format == 'percentage') {
    return `${percentageDecimalFormat.format(cleanedNumericValue)}%`
  } else if (format == 'years') {
    return `${cleanedNumericValue} years`
  }

  return value
}

export const updateFormattedInputSelection = function(input)  {
  const selectionStart = input.selectionStart
  const selectionEnd = input.selectionEnd

  let startPositionValue = input.value.substring(0, selectionStart)
  let cleanStartPositionValue = startPositionValue.replace(cleanNumberRegex, '')
  let startOffset = startPositionValue.length - cleanStartPositionValue.length

  let endPositionValue = input.value.substring(0, selectionEnd)
  let cleanEndPositionValue = endPositionValue.replace(cleanNumberRegex, '')
  let endOffset = endPositionValue.length - cleanEndPositionValue.length

  input.value = input.value.replace(cleanNumberRegex, '')

  input.setSelectionRange(
    selectionStart - startOffset,
    selectionEnd -  endOffset
  )
}


